import printIcon from "@assets/images/print.svg";
import { Box, Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
// import MyTypography from "@saleor/components/MyTypography";
import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import useAppState from "@saleor/hooks/useAppState";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import InlineSVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

interface BottomBarProps {
  onDownload: () => void;
  onPrint: () => void;
  dataCount: number;
}

interface propsStyleType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

const useStyles = makeStyles<propsStyleType>(
  () => ({
    bottomBar: {
      position: "fixed",
      bottom: 0,
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: 20,
      height: 90,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center",
      zIndex: 99,
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)"
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center"
    },
    ml_20: {
      marginLeft: "2rem"
    },
    icon: {
      marginRight: "1.1rem"
    },
    btnCustom: {
      width: 180,
      height: 48
      // padding: "12px 24.5px"
    }
  }),
  { name: "BottomBar" }
);

const SVGdownload = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="currentColor"
      d="M1 13V14C1 14.7956 1.31607 15.5587 1.87868 16.1213C2.44129 16.6839 3.20435 17 4 17H14C14.7956 17 15.5587 16.6839 16.1213 16.1213C16.6839 15.5587 17 14.7956 17 14V13M13 9L9 13M9 13L5 9M9 13V1"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const BottomBar: React.FC<BottomBarProps> = props => {
  const { onDownload, onPrint, dataCount } = props;
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });

  return (
    <div className={classes.bottomBar}>
      <div className={classes.barRight}>
        <div className={classes.ml_20}>
          <Button
            id="printButton"
            className={classes.btnCustom}
            variant={"outlined"}
            color={"secondary"}
            disabled={!dataCount}
            // disabled={disabled}
            onClick={onPrint}
          >
            <InlineSVG src={printIcon} />
            <Box ml={1.5} />
            <MyTypography variant="button2">
              <FormattedMessage defaultMessage={"Print"} />
            </MyTypography>
          </Button>
        </div>
        <div className={classes.ml_20}>
          <Button
            id="downloadExcel"
            className={classes.btnCustom}
            variant={"contained"}
            color={"secondary"}
            disabled={!dataCount}
            // disabled={disabled}
            onClick={onDownload}
          >
            <SVGdownload />
            <Box ml={1.5} />
            <MyTypography variant="button2">
              <FormattedMessage defaultMessage={"Download Excel"} />
            </MyTypography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
